"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapProcessInstance = exports.mapLogEntry = exports.mapExternalTask = exports.mapDataObjectInstance = exports.mapCronjobHistory = exports.mapCronjobConfiguration = exports.mapProcessToken = exports.mapUserTask = exports.mapServiceTask = exports.mapManualTask = exports.mapEvent = exports.mapEmptyActivity = exports.mapReceiveTask = exports.mapCallActivity = exports.mapFlowNodeInstance = exports.mapActiveToken = exports.mapProcessModel = exports.mapProcessDefinition = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
function mapProcessDefinition(rawDefinition) {
    const processDefinition = {
        processDefinitionId: rawDefinition.processDefinitionId,
        hash: rawDefinition.hash,
        xml: rawDefinition.xml,
        processModels: [],
        deployedAt: new Date(rawDefinition.deployedAt),
        deployedByUserId: rawDefinition.deployedByUserId,
    };
    for (const rawProcess of rawDefinition.processModels) {
        processDefinition.processModels.push(mapProcessModel(rawProcess));
    }
    return processDefinition;
}
exports.mapProcessDefinition = mapProcessDefinition;
function mapProcessModel(rawModel) {
    return {
        processDefinitionId: rawModel.processDefinitionId,
        processModelId: rawModel.processModelId,
        processModelName: rawModel.processModelName,
        isExecutable: rawModel.isExecutable,
        laneSet: rawModel.laneSet,
        flowNodes: rawModel.flowNodes,
        startEvents: rawModel.startEvents,
        endEvents: rawModel.endEvents,
        flowNodeIds: rawModel.flowNodeIds,
        startEventIds: rawModel.startEventIds,
        endEventIds: rawModel.endEventIds,
    };
}
exports.mapProcessModel = mapProcessModel;
function mapActiveToken(data) {
    return {
        processInstanceId: data.processInstanceId,
        processModelId: data.processModelId,
        correlationId: data.correlationId,
        flowNodeId: data.flowNodeId,
        flowNodeInstanceId: data.flowNodeInstanceId,
        ownerId: data.ownerId,
        createdAt: new Date(data.createdAt),
        payload: data.payload,
    };
}
exports.mapActiveToken = mapActiveToken;
function mapFlowNodeInstance(data) {
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.callActivity) {
        return mapCallActivity(data);
    }
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.emptyActivity) {
        return mapEmptyActivity(data);
    }
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.manualTask) {
        return mapManualTask(data);
    }
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.serviceTask) {
        return mapServiceTask(data);
    }
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.userTask) {
        return mapUserTask(data);
    }
    if (data.flowNodeType === atlas_engine_sdk_1.BpmnType.receiveTask) {
        return mapReceiveTask(data);
    }
    if (data.eventType != undefined) {
        return mapEvent(data);
    }
    return createBaseFlowNodeInstance(data);
}
exports.mapFlowNodeInstance = mapFlowNodeInstance;
function mapCallActivity(data) {
    return {
        ...createBaseFlowNodeInstance(data),
        childProcessInstanceId: data.childProcessInstanceId,
    };
}
exports.mapCallActivity = mapCallActivity;
function mapReceiveTask(data) {
    return {
        ...createBaseFlowNodeInstance(data),
        sendTaskFlowNodeInstanceId: data.sendTaskFlowNodeInstanceId,
    };
}
exports.mapReceiveTask = mapReceiveTask;
function mapEmptyActivity(data) {
    return createBaseFlowNodeInstance(data);
}
exports.mapEmptyActivity = mapEmptyActivity;
function mapEvent(data) {
    return {
        ...createBaseFlowNodeInstance(data),
        eventName: data.eventName,
        customCorrelationId: data.customCorrelationId,
    };
}
exports.mapEvent = mapEvent;
function mapManualTask(data) {
    return {
        ...createBaseFlowNodeInstance(data),
        finishedByUserId: data.finishedByUserId,
    };
}
exports.mapManualTask = mapManualTask;
function mapServiceTask(data) {
    const serviceTaskInstance = createBaseFlowNodeInstance(data);
    if (data.externalTaskData) {
        serviceTaskInstance.externalTaskData = {
            externalTaskId: data.externalTaskData.externalTaskId,
            workerId: data.externalTaskData.workerId,
            topic: data.externalTaskData.topic,
            state: data.externalTaskData.state,
            isSingleTry: data.externalTaskData.isSingleTry,
            lockExpirationTime: data.externalTaskData.lockExpirationTime ? new Date(data.externalTaskData.lockExpirationTime) : undefined,
            payload: data.externalTaskData.payload,
            result: data.externalTaskData.result,
            error: typeof data.error === 'string' ? (0, atlas_engine_sdk_1.deserializeJson)(data.error) : data.error,
            finishedAt: data.externalTaskData.finishedAt ? new Date(data.externalTaskData.finishedAt) : undefined,
        };
    }
    return serviceTaskInstance;
}
exports.mapServiceTask = mapServiceTask;
function mapUserTask(data) {
    return {
        ...createBaseFlowNodeInstance(data),
        assignedUserIds: data.assignedUserIds,
        actualOwnerId: data.actualOwnerId,
        finishedByUserId: data.finishedByUserId,
        userTaskConfig: data.userTaskConfig,
        userTaskConfigModel: data.userTaskConfigModel,
    };
}
exports.mapUserTask = mapUserTask;
function createBaseFlowNodeInstance(data) {
    return {
        flowNodeInstanceId: data.flowNodeInstanceId,
        flowNodeId: data.flowNodeId,
        flowNodeName: data.flowNodeName,
        flowNodeLane: data.flowNodeLane,
        flowNodeType: data.flowNodeType,
        previousFlowNodeInstanceId: data.previousFlowNodeInstanceId,
        eventType: data.eventType,
        parentProcessInstanceId: data.parentProcessInstanceId,
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        processInstanceId: data.processInstanceId,
        correlationId: data.correlationId,
        state: data.state,
        tokens: data.tokens.map(mapProcessToken),
        ownerId: data.ownerId,
        metaInfo: data.metaInfo,
        error: typeof data.error === 'string' ? (0, atlas_engine_sdk_1.deserializeJson)(data.error) : data.error,
        startedAt: data.startedAt ? new Date(data.startedAt) : undefined,
        finishedAt: data.finishedAt ? new Date(data.finishedAt) : undefined,
    };
}
function mapProcessToken(data) {
    return {
        flowNodeInstanceId: data.flowNodeInstanceId,
        createdAt: new Date(data.createdAt),
        type: data.type,
        payload: typeof data.payload === 'string' ? (0, atlas_engine_sdk_1.deserializeJson)(data.payload) : data.payload,
    };
}
exports.mapProcessToken = mapProcessToken;
function mapCronjobConfiguration(data) {
    return {
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        startEventId: data.startEventId,
        crontab: data.crontab,
        nextExecution: new Date(data.nextExecution),
    };
}
exports.mapCronjobConfiguration = mapCronjobConfiguration;
function mapCronjobHistory(data) {
    return {
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        startEventId: data.startEventId,
        crontab: data.crontab,
        executedAt: new Date(data.executedAt),
    };
}
exports.mapCronjobHistory = mapCronjobHistory;
function mapDataObjectInstance(data) {
    return {
        dataObjectId: data.dataObjectId,
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        processInstanceId: data.processInstanceId,
        flowNodeInstanceId: data.flowNodeInstanceId,
        value: data.value,
        createdAt: new Date(data.createdAt),
        updatedAt: new Date(data.updatedAt),
    };
}
exports.mapDataObjectInstance = mapDataObjectInstance;
function mapExternalTask(data) {
    return {
        id: data.id,
        workerId: data.workerId,
        topic: data.topic,
        isSingleTry: data.isSingleTry,
        flowNodeInstanceId: data.flowNodeInstanceId,
        correlationId: data.correlationId,
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        processInstanceId: data.processInstanceId,
        ownerId: data.ownerId,
        payload: data.payload,
        lockExpirationTime: new Date(data.lockExpirationTime),
        state: data.state,
        finishedAt: data.finishedAt ? new Date(data.finishedAt) : undefined,
        result: data.result,
        error: typeof data.error === 'string' ? (0, atlas_engine_sdk_1.deserializeJson)(data.error) : data.error,
        createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    };
}
exports.mapExternalTask = mapExternalTask;
function mapLogEntry(data) {
    return {
        eventType: data.eventType,
        timestamp: new Date(data.timestamp),
        processModelId: data.processModelId,
        flowNodeId: data.flowNodeId,
        flowNodeInstanceId: data.flowNodeInstanceId,
        flowNodeType: data.flowNodeType,
        processInstanceId: data.processInstanceId,
        correlationId: data.correlationId,
        tokenPayload: data.tokenPayload,
        logLevel: data.logLevel,
    };
}
exports.mapLogEntry = mapLogEntry;
function mapProcessInstance(data) {
    return {
        correlationId: data.correlationId,
        processDefinitionId: data.processDefinitionId,
        processModelId: data.processModelId,
        processModelName: data.processModelName,
        processInstanceId: data.processInstanceId,
        parentProcessInstanceId: data.parentProcessInstanceId,
        hash: data.hash,
        xml: data.xml,
        state: data.state,
        error: typeof data.error === 'string' ? (0, atlas_engine_sdk_1.deserializeJson)(data.error) : data.error,
        ownerId: data.ownerId,
        startedByRootAccessToken: data.startedByRootAccessToken,
        createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
        finishedAt: data.finishedAt ? new Date(data.finishedAt) : undefined,
        restartedAt: data.restartedAt ? new Date(data.restartedAt) : undefined,
        terminatedByUserId: data.terminatedByUserId,
        durationInMilliseconds: data.durationInMilliseconds,
        startEventId: data.startEventId,
        startEventType: data.startEventType,
        startToken: data.startToken,
        endEventId: data.endEventId,
        endEventType: data.endEventType,
        endToken: data.endToken,
        metadata: data.metadata,
        correlation: data.correlation,
    };
}
exports.mapProcessInstance = mapProcessInstance;
//# sourceMappingURL=Mappers.js.map